export const IMAGES = {
  hero: [
    "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbmRpYW4lMjB3ZWRkaW5nfGVufDB8fHx8MTc4NDczMzgzMXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1761472606347-bfebc5a3e546?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxyb3lhbCUyMHBhbGFjZSUyMGV2ZW50fGVufDB8fHx8MTc4NDczMzgzMXww&ixlib=rb-4.1.0&q=85"
  ],
  services: {
    catering: "https://images.unsplash.com/photo-1740047602722-b4993b79e4b7",
    rituals: "https://images.pexels.com/photos/8887142/pexels-photo-8887142.jpeg",
    welcome: "https://images.unsplash.com/photo-1597897569252-9df44c7de0db",
    management: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxldmVudCUyMG1hbmFnZW1lbnR8ZW58MHx8fHwxNzg0NzMzODMxfDA&ixlib=rb-4.1.0&q=85"
  },
  locations: {
    jaipur: "https://images.unsplash.com/photo-1695395550316-8995ae9d35ff",
    udaipur: "https://images.unsplash.com/photo-1633702738734-443da2c18f3c",
    ranthambore: "https://images.unsplash.com/photo-1698382439843-ca033a6079c0",
    desert: "https://images.unsplash.com/photo-1559767180-47d8f4919e5d"
  },
  portfolio: [
    "https://images.unsplash.com/photo-1654764746225-e63f5e90facd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBpbmRpYW4lMjB3ZWRkaW5nfGVufDB8fHx8MTc4NDczMzgzMXww&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/33485963/pexels-photo-33485963.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1653614709975-3349e27775bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwY29ycG9yYXRlJTIwc2V0dXB8ZW58MHx8fHwxNzg0NzMzODMxfDA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/16137163/pexels-photo-16137163.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/32261804/pexels-photo-32261804.jpeg"
  ],
  founder: "https://images.unsplash.com/photo-1724225618359-a1d2763326f9"
};
